export const PATIENT_OTP_TOKEN_LENGTH = 6 as const
